import React from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
import Features from 'app/features';
import { selectShowFeatureFlags } from 'ducks/feature-flags';
import FeatureGuard from './feature-guard';
import Form from './form';
import TabNavigation from '../components/tab-navigation';

const ShowSettingsAccess = ({ hasAcastAccess, params }) => (
  <div>
    {hasAcastAccess && <TabNavigation />}
    <FeatureGuard showId={params.showId}>
      <Form params={params} />
    </FeatureGuard>
  </div>
);

ShowSettingsAccess.propTypes = {
  hasAcastAccess: T.bool.isRequired,
  params: T.shape({
    showId: T.string.isRequired,
  }).isRequired,
};

export default connect((state, { params }) => {
  const featureFlags = selectShowFeatureFlags(params.showId)(state);

  return {
    hasAcastAccess: featureFlags.includes(Features.AcastAccess),
  };
})(ShowSettingsAccess);
